export const parseDefault = (_schema) => {
    return "z.any()";
};
